import { RootState } from "common/reducers";
import { PaymentRecord } from "common/records/Payment";
import { Nullable } from "common/types";
import { PaymentAuthorizationRecord, paymentProviders } from "common/records/PaymentAuthorizationRecord";
import { createSelector } from "reselect";

export const payment = (state: RootState, { paymentId }: { paymentId: Nullable<number> }) => {
  if (!paymentId) {
    return null;
  }
  return state.getIn(["payments", "byId"]).get(paymentId);
};

/**
 * Returns the payment authorization info for the given orgId
 *
 * @param {RootState} state
 * @param {{orgId: number}} props
 * @returns {Map}
 */
export const paymentAuth = (state: RootState, props: { orgId: number }): PaymentAuthorizationRecord =>
  state.getIn(["payments", "authByOrgId", props.orgId]);

/**
 * Returns the first PaymentRequestKind that is authorized for the given orgId, based on Payment Providers
 *
 * @param {RootState} state
 * @param {{orgId: number}} props
 * @returns {PaymentRequestKind | ""}
 */
export const paymentAuthRequestKind = createSelector([paymentAuth], (auth: PaymentAuthorizationRecord) => {
  if (!auth) return "";

  const found = paymentProviders.find((v) => auth.get(v as any));

  if (!found) return "";

  switch (found) {
    case "occ_pay":
      return "occ_pay";
    case "pay_simple":
      return "paysimple";
    default:
      return "";
  }
});
